import { QueryAdminDashboardResponse } from "../../../../types";
import { AlertTitle, Typography as T } from "@mui/material";
import Alert from "@mui/material/Alert";
import { InviteProgramAdminsBox } from "../components";

const ProgramNotLive = ({ data }: { data: QueryAdminDashboardResponse }) => {
  return (
    <div className="flex flex-col" style={{ gap: 16 }}>
      <Alert severity="info">
        <AlertTitle>Your Program is Not Yet Live</AlertTitle>
        <T variant="mdMed" className="w-50">
          We are currently formatting your payroll files and employee marketing
          materials. Before the program goes live we will reach out to you
          directly for review.
        </T>
      </Alert>
      <InviteProgramAdminsBox />
    </div>
  );
};

export default ProgramNotLive;
